import React from 'react';
import { Divider } from '../../../SectionDivider/Divider';
import { getDividerHeight } from '../../../SectionDivider/heights';

export function WidgetDivider({ divider, color = 'section', ...rest }) {
  if (!divider || !divider.preset) return null;

  const { category, sectionColorOverride } = this.base;
  const resolvedColor =
    (color === 'section' && category === 'primary' && sectionColorOverride) ||
    String(this.mapPropValue('backgroundColor', color));

  const height = getDividerHeight(divider);

  return this.merge(
    {
      tag: 'div',
      style: { color: resolvedColor, position: 'relative', height: 0 },
      children: (
        <div
          style={{
            position: 'absolute',
            top: `calc(-1 * ${height})`,
            left: 0,
            width: '100%',
            height,
            zIndex: 1,
            pointerEvents: 'none'
          }}
        >
          <Divider
            preset={ divider.preset }
            amplitude={ divider.amplitude }
            depth={ divider.depth }
            position={ divider.position }
            steepness={ divider.steepness }
            softness={ divider.softness }
            fadeOpacity={ divider.fadeOpacity }
            fadeDirection={ divider.fadeDirection }
            fadeMidpoint={ divider.fadeMidpoint }
            height={ height }
          />
        </div>
      )
    },
    rest
  );
}
